import React, { useEffect, useState } from "react";
import general, { imgPlaceholder } from "../../general";
import { Link, useHistory } from "react-router-dom";
import Image from "../../lib/Image";
import Dialog from "../../lib/Dialog";
import { splitStr } from "../../utils/commonFunc";

// 专题信息展示
export default (props) => {
  const history = useHistory();

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const getProjectDetail = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    let data = {};
    data.type = props.query.type;
    if (props.query.id) {
      data.id = props.query.id;
    } else {
      Dialog.error("缺少参数", 1, () => history.goBack);
      return;
    }
    general.axios
      .post("/v3/base/appspecial/getSpecialList", data)
      .finally(() => {
        setLoading(false);
      })
      .then((res) => {
        let { status, data } = res.data;
        console.log("专题详情", res);
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }

        if (!data.list.url_img) {
          Dialog.error("该活动已过期...");
          setTimeout(() => {
            general.history.push("/");
          }, 1000);
        } else {
          setData(data.list);
          console.log("专题详情", data);
        }
      })
      .catch((err) => {
        Dialog.error("getProjectDetail " + err.message);
      });
  };

  useEffect(() => {
    getProjectDetail();
  }, []);

  useEffect(() => {
    props.setTitle(data?.title);
  }, [data]);

  return (
    <>
      {data && !loading ? (
        <>
          <div className="game-project">
            <div className="project-img">
              <Image src={data.url_img} alt="" />
            </div>

            {data.describe && (
              <div className="project-info">{data.describe}</div>
            )}

            <div className="games">
              {data.details?.map((game) => (
                <Link
                  key={game.game_id}
                  to={"/game?id=" + game.game_id}
                  className="game-list-global-type"
                  style={{
                    marginBottom: "8px",
                    padding: "10px 0 10px 10px",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.08)",
                  }}
                >
                  <div className="game-list-global-type-left">
                    <div className="icon">
                      <Image src={game.icon} />
                    </div>

                    <div className="data">
                      <div className="name">
                        <div className="name-main">
                          {game.game_name_main || game.game_name}
                        </div>

                        {game?.game_tags?.is_special_server_game == 2 && (
                          <div className="dedicated-server">专服</div>
                        )}
                      </div>

                      <div className="desc">
                        {splitStr(game.version)}
                        {game.game_name_branch && (
                          <>
                            <div className="circle"></div>
                            {game.game_name_branch}
                          </>
                        )}
                      </div>

                      <div className="info">
                        {game.benefits && (
                          <>
                            {game?.is_trial_game == 2 ? (
                              <>
                                <div className="play-tag">有奖试玩</div>
                                {game.benefits
                                  ?.split("+")
                                  .slice(0, 1)
                                  .map((item, index) => (
                                    <div key={index} className="tag">
                                      {item}
                                    </div>
                                  ))}
                              </>
                            ) : (
                              game.benefits
                                ?.split("+")
                                .slice(0, 2)
                                .map((item, index) => (
                                  <div key={index} className="tag">
                                    {item}
                                  </div>
                                ))
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {game?.game_tags?.is_premium_game == 2 ? (
                    <div
                      className="is-premium"
                      style={{
                        backgroundImage:
                          "url('/resources/common/boutique.png')",
                      }}
                    >
                      {game.discount < 1 ? (
                        <p className="is-premium-discount">
                          {parseFloat((game.discount * 10).toFixed(2))}折
                        </p>
                      ) : null}
                      <p className="boutique">精品游戏</p>
                    </div>
                  ) : game?.game_tags?.is_free_version == 2 ? (
                    <div className="is-free-version">
                      <span>免费版</span>
                    </div>
                  ) : (
                    <>
                      {game.discount < 1 ? (
                        <div className="discount">
                          {parseFloat((game.discount * 10).toFixed(2))}折
                        </div>
                      ) : null}
                    </>
                  )}
                </Link>
              ))}
            </div>
            <div className="view-end">别撩啦！已经到底啦~</div>
          </div>
        </>
      ) : (
        <div className="game-detail">
          <div className="game-skeleton">
            <div className="a" />
            <div className="b">
              <img src={imgPlaceholder.default} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
